import React from 'react';
import SchemaModal from './SchemaModal';
import './ConfirmDialog.css';

/**
 * Baustein — ConfirmDialog.
 * Bestätigungsdialog auf Basis von SchemaModal (size sm). Ersetzt window.confirm.
 * Trägt KEINE Domain-Logik — der Aufrufer entscheidet, was onConfirm tut.
 *
 * Props:
 *   open, onOpenChange — Radix-Steuerung (analog SchemaModal)
 *   title              — Frage als Titel (z.B. „Freund entfernen?")
 *   description         — erklärender Satz darunter (optional)
 *   onConfirm          — Callback für den Primär-Button
 *   confirmLabel       — Text des Primär-Buttons (default „Bestätigen")
 *   cancelLabel        — Text des Abbrechen-Buttons (default „Abbrechen")
 *   tone               — 'default' | 'danger' (default 'default'); 'danger' → btn-danger
 *
 * Beispiel:
 *   <ConfirmDialog
 *     open={!!action}
 *     onOpenChange={(o) => { if (!o) setAction(null); }}
 *     title="Freund entfernen?"
 *     description="Anna wird aus deinen Freunden entfernt."
 *     confirmLabel="Entfernen"
 *     tone="danger"
 *     onConfirm={handleRemove}
 *   />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmLabel = 'Bestätigen',
  cancelLabel = 'Abbrechen',
  tone = 'default',
}) {
  return (
    <SchemaModal
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={title}
      footer={
        <>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => onOpenChange?.(false)}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={tone === 'danger' ? 'btn-danger' : 'btn-primary'}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      {description && <p className="confirm-dialog__text">{description}</p>}
    </SchemaModal>
  );
}
